const VerifyStaffIcon = ({
  height = "40px",
  width = "40px",
}: {
  height?: string;
  width?: string;
}) => {
  return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        style={{ width: `${width}`, height: `${height}` }} // Use inline styles here
        viewBox="0 0 40 40"
        fill="none"
      >
        <g clipPath="url(#clip0_699_5839)">
          <path
            d="M32 0.5H8C3.85786 0.5 0.5 3.85786 0.5 8V32C0.5 36.1421 3.85786 39.5 8 39.5H32C36.1421 39.5 39.5 36.1421 39.5 32V8C39.5 3.85786 36.1421 0.5 32 0.5Z"
            fill="white"
            stroke="#E9EEFE"
          />
          <mask
            id="mask0_699_5839"
            mask-type="luminance"
            maskUnits="userSpaceOnUse"
            x="8"
            y="8"
            width="24"
            height="24"
          >
            <path d="M32 8H8V32H32V8Z" fill="white" />
          </mask>
          <g mask="url(#mask0_699_5839)">
            <mask
              id="mask1_699_5839"
              mask-type="luminance"
              maskUnits="userSpaceOnUse"
              x="8"
              y="8"
              width="24"
              height="24"
            >
              <path d="M32 8H8V32H32V8Z" fill="white" />
            </mask>
            <g mask="url(#mask1_699_5839)">
              <path
                d="M20.3125 30.963C18.5275 31.0071 15.0203 30.7286 13.8742 30.4572C13.0928 30.2927 12.3583 29.838 11.8052 29.2052C11.2521 28.5724 10.9024 27.79 10.8208 26.9993L10.818 26.9749C10.7591 26.3845 10.7415 25.7907 10.7655 25.1979C10.7655 25.1979 10.7214 24.6743 10.8208 23.725C10.8208 23.7171 10.8208 23.7086 10.8208 23.7007C10.9045 22.9212 11.2533 22.1941 11.8089 21.641C12.3674 21.082 13.0993 20.7296 13.8846 20.6416C15.0344 20.5202 18.5332 20.4541 20.3116 20.4541C22.09 20.4541 24.9438 20.5202 26.0936 20.6416C26.8788 20.7297 27.6107 21.0821 28.1692 21.641C28.7255 22.1947 29.0742 22.923 29.1569 23.7035V23.7274C29.2563 24.6771 29.2432 25.1983 29.2432 25.1983C29.2459 25.7932 29.2173 26.3877 29.1574 26.9796C29.1574 26.9875 29.1574 26.9955 29.155 27.0035C29.0735 27.7943 28.7242 28.5757 28.1707 29.2099C27.6171 29.8441 26.8825 30.2969 26.1011 30.4614C24.9569 30.7193 22.0971 30.9752 20.3125 30.963Z"
                fill="#183883"
              />
              <path
                d="M25.5598 20.5961C24.2135 20.5023 21.8567 20.4531 20.3098 20.4531C18.5313 20.4531 15.0326 20.5197 13.8828 20.6406C13.0981 20.7292 12.3669 21.0817 11.809 21.6405C11.2536 22.1936 10.9049 22.9207 10.8213 23.7002V23.7245C10.7187 24.6737 10.7656 25.1973 10.7656 25.1973C10.7424 25.7902 10.7607 26.384 10.8204 26.9744L10.8232 26.9987C10.8709 27.4429 10.9958 27.8753 11.1921 28.2766C12.0834 28.4735 12.9934 28.5726 13.9062 28.5723C19.212 28.5723 23.7467 25.2634 25.5598 20.5961Z"
                fill="#5170CD"
              />
              <path
                d="M19.8841 19.1178C22.9542 19.1178 25.443 16.629 25.443 13.5589C25.443 10.4888 22.9542 8 19.8841 8C16.814 8 14.3252 10.4888 14.3252 13.5589C14.3252 16.629 16.814 19.1178 19.8841 19.1178Z"
                fill="#E62D38"
              />
              <mask
                id="mask2_699_5839"
                mask-type="luminance"
                maskUnits="userSpaceOnUse"
                x="22"
                y="22"
                width="10"
                height="10"
              >
                <path d="M32 22H22V32H32V22Z" fill="white" />
              </mask>
              <g mask="url(#mask2_699_5839)">
                <mask
                  id="mask3_699_5839"
                  mask-type="luminance"
                  maskUnits="userSpaceOnUse"
                  x="22"
                  y="22"
                  width="10"
                  height="10"
                >
                  <path d="M31.56 22H22V31.56H31.56V22Z" fill="white" />
                </mask>
                <g mask="url(#mask3_699_5839)">
                  <path
                    d="M26.78 22C24.1402 22 22 24.1394 22 26.78C22 29.4206 24.1402 31.56 26.78 31.56C29.4198 31.56 31.56 29.4193 31.56 26.78C31.56 24.1407 29.4198 22 26.78 22Z"
                    fill="#2AD352"
                  />
                  <path
                    d="M22 26.78C21.9989 27.5701 22.1946 28.348 22.5693 29.0436C23.0467 29.1838 23.5418 29.2548 24.0394 29.2544C26.913 29.2544 29.2425 26.9249 29.2425 24.0513C29.2429 23.5458 29.1697 23.043 29.0251 22.5587C28.3341 22.1906 27.5629 21.9987 26.78 22C24.1402 22 22 24.1394 22 26.78Z"
                    fill="#74DA7F"
                  />
                  <path
                    d="M29.5062 25.9879L26.6332 29.0051C26.5549 29.0873 26.4608 29.1528 26.3566 29.1977C26.2524 29.2426 26.1402 29.266 26.0267 29.2665H26.023C25.9101 29.2666 25.7984 29.2439 25.6945 29.1999C25.5906 29.156 25.4966 29.0916 25.418 29.0105L23.8935 27.4402C23.8147 27.3612 23.7524 27.2672 23.7102 27.1639C23.668 27.0606 23.6468 26.9499 23.6477 26.8383C23.6487 26.7267 23.6718 26.6164 23.7157 26.5137C23.7596 26.4111 23.8235 26.3183 23.9036 26.2405C23.9837 26.1628 24.0784 26.1018 24.1823 26.0609C24.2861 26.0201 24.3971 26.0003 24.5087 26.0027C24.6203 26.0051 24.7303 26.0297 24.8323 26.0749C24.9343 26.1202 25.0263 26.1852 25.103 26.2663L26.017 27.2078L28.2854 24.8256C28.3614 24.7441 28.4528 24.6785 28.5543 24.6326C28.6558 24.5866 28.7655 24.5613 28.8768 24.558C28.9882 24.5547 29.0991 24.5735 29.2032 24.6133C29.3072 24.6531 29.4023 24.7132 29.483 24.79C29.5637 24.8669 29.6284 24.9589 29.6733 25.0609C29.7182 25.1629 29.7424 25.2728 29.7445 25.3842C29.7467 25.4956 29.7267 25.6063 29.6858 25.7099C29.6449 25.8135 29.5839 25.908 29.5062 25.9879Z"
                    fill="white"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
        <defs>
          <clipPath id="clip0_699_5839">
            <rect width="40" height="40" fill="white" />
          </clipPath>
        </defs>
      </svg>
  );
};
export default VerifyStaffIcon;
